// Default DEPLOY_ENV to production
const { DEPLOY_ENV: _DEPLOY_ENV } = process.env;
const DEPLOY_ENV = _DEPLOY_ENV || 'production';
const { NODE_ENV, VERSION } = process.env;
export { NODE_ENV, DEPLOY_ENV, VERSION };
export const SSO_RETURN_URL_KEY = 'elevio_return_url';
export const NOTIFICATION_KEY = 'notification_key';
export const BASE_CDN = DEPLOY_ENV === 'production'
    ? 'https://cdn.elev.io'
    : 'https://cdn.elevio-staging.com';
export const API_EVENTS_URL = DEPLOY_ENV === 'production'
    ? 'https://events.elev.io/v1/events'
    : 'https://events.elevio-staging.com/v1/events';
export const IPA_URL = DEPLOY_ENV === 'production'
    ? 'https://ipa.elev.io/api'
    : 'https://ipa.elevio-staging.com/api';
export const GRAPHQL_API_URL = DEPLOY_ENV === 'production'
    ? 'https://ipa.elev.io/grappa/graphql'
    : 'https://ipa.elevio-staging.com/grappa/graphql';
//# sourceMappingURL=config.js.map